import React from 'react';

const AuthFormWrapper = ({ children }) => (
  <div className="auth-form-wrapper px-md-3 px-lg-4 px-xl-5 px-sm-2">{children}</div>
);

export default AuthFormWrapper;



// WEBPACK FOOTER //
// src/modules/auth/components/form/AuthFormWrapper.js